import { render, staticRenderFns } from "./KBTime.vue?vue&type=template&id=7b71ed82&scoped=true&"
import script from "./KBTime.vue?vue&type=script&lang=js&"
export * from "./KBTime.vue?vue&type=script&lang=js&"
import style0 from "./KBTime.vue?vue&type=style&index=0&id=7b71ed82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71ed82",
  null
  
)

export default component.exports